<template>
  <div class="home">
    <div class="headera">
      <div class="logo">
        <!-- <img src="../assets/area/4logo.png" alt="" style="margin: 20px auto" /> -->
        {{ institution.branchName }}
      </div>
      <!-- <img
        src="../assets/org/icon_back.png"
        alt=""
        class="goBack"
        @click="goBack"
      /> -->
      <!-- <div class="tipsBox"> -->
        <div class="back">
          <span class="tips" @click="gotopage('home')">首页</span>
          <span class="tips" @click="gotopage('site')">区域</span>
        </div>
        <div class="datetime">
          <el-select
            style="color: black;margin-left: 15px;"
            v-model="orgId"
            placeholder=""
            @change="seleorg"
          >
            <el-option
              v-for="item in orgData"
              :key="item.id"
              :label="item.branchName"
              :value="item.branchId"
            >
            </el-option>
          </el-select>
        </div>
        <div class="back1">
          <span class="tips" @click="gotopage('area')">中心带站</span>
        </div>
      <!-- </div> -->
      <el-select
        class="stationSelect"
        style="color: black;width: 220px;"
        v-model="organization"
        placeholder=""
        @change="seleorganization"
      >
        <el-option
          v-for="item in menuData"
          :key="item.id"
          :label="item.branchName"
          :value="item.branchId"
        >
        </el-option>
      </el-select>
    </div>

    <div class="main">
      <div class="mainTop">
        <div class="maTopInfo2" v-if="ishow">
          <div class="inItem2">
            <img src="../assets/newicon/lrxx.png" alt="" class="smtopImg1" />
            <div class="infoValue2">
              <p  class="topNum2">{{topinfoArr[0].typeName }}</p>
              <p class="topNum21" v-for="(item1, index1) in topinfoArr[0].dataList" :key="index1">
                <span>{{ item1.dataSubCodeName }}</span
                ><span>{{ item1.dataValue }}</span>
              </p>
            </div>
          </div>
          <div class="inItem2">
            <img src="../assets/newicon/ylsm.png" alt="" class="smtopImg1" />
            <div class="infoValue2">
              <p  class="topNum2">{{topinfoArr[1].typeName }}</p>
              <p class="topNum21" v-for="(item1, index1) in topinfoArr[1].dataList" :key="index1">
                <span>{{ item1.dataSubCodeName }}</span
                ><span>{{ item1.dataValue }}</span>
              </p>
            </div>
          </div>
          <div class="inItem2">
            <img src="../assets/newicon/zdll.png" alt="" class="smtopImg1" />
            <div class="infoValue2">
              <p  class="topNum2">{{topinfoArr[2].typeName }}</p>
              <p class="topNum21" v-for="(item1, index1) in topinfoArr[2].dataList" :key="index1">
                <span>{{ item1.dataSubCodeName }}</span
                ><span>{{ item1.dataValue }}</span>
              </p>
            </div>
          </div>
          <div class="inItem2">
            <img src="../assets/newicon/gyhd.png" alt="" class="smtopImg1" />
            <div class="infoValue2">
              <p  class="topNum2">{{topinfoArr[3].typeName }}</p>
              <p class="topNum21" v-for="(item1, index1) in topinfoArr[3].dataList" :key="index1">
                <span>{{ item1.dataSubCodeName }}</span
                ><span>{{ item1.dataValue }}</span>
              </p>
            </div>
          </div>
          <div class="inItem2">
            <img src="../assets/newicon/jkfw.png" alt="" class="smtopImg1" />
            <div class="infoValue2">
              <p  class="topNum2">{{topinfoArr[4].typeName }}</p>
              <p class="topNum21" v-for="(item1, index1) in topinfoArr[4].dataList" :key="index1">
                <span>{{ item1.dataSubCodeName }}</span
                ><span>{{ item1.dataValue }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="mainBottom">
        <div class="btml">
          <div class="btmlitem">
            <p style="margin: 0 ;padding-top: 10px">服务站简介</p>
            <div class="textContent">
              {{ detailInfo.profile }}
            </div>
          </div>
          <div class="btmlitem">
            <div style="height: 20px; width: 100%"></div>
            <swiper class="swiper" :options="swiperOption" :auto-update="true">
              <swiper-slide
                v-for="staff in staffList"
                :key="staff.id"
              >
                <ul style="height: 100%">
                  <li style="height: 100%">
                    <div class="avatar" style="height: 100%">
                      <img
                        style="height: 100%"
                        :src="`/ophApi/commonAttachDown/download?id=${staff.avatarId}`"
                        alt=""
                      />
<!--                      <div>{{ staff.staffName }}</div>-->
                    </div>
<!--                    <div class="dscp">{{ staff.staffIntroduce }}</div>/-->
                  </li>
                </ul>
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <div class="btmc">
          <div class="rimgItem"  style="width:100%;height:100%">
            <swiper
            style="width:100%;height:100%"
              :options="swiperOption"
              @slideChangeTransitionEnd="onSlideChange"
            >
              <swiper-slide
              style="width:100%;height:100%"
                v-for="item in detailInfo.attachList"
                :key="item.id"
              >
                <img
                style="width:100%;height:100%"
                  :src="`/ophApi/commonAttachDown/download?id=${item.id}`"
                  alt=""
                />
                <div class="staioName">{{item.fileDescription}}</div>
              </swiper-slide>


            </swiper>
          </div>
        </div>
        <div class="btmr">
          <div class="btmlitem">
            <div id="highchart-disease-bar"></div>
          </div>
          <div class="btmlitem">
            <div style="height: 20px; width: 100%"></div>
            <swiper
              :options="swiperOption"
              @slideChangeTransitionEnd="onSlideChange"
            >
              <swiper-slide v-for="item in activity" :key="item.id">
                <img
                  :src="`/ophApi/commonAttachDown/download?id=${item}`"
                  alt=""
                />
              </swiper-slide>

              <!-- <div class="swiper-pagination" slot="pagination"></div> -->
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Hls from "hls.js";
import moment from "moment";
import Highcharts from "highcharts";
import diseaseBarChartOpts from "@/charts/disease-bar.js";

import mapStyleJson from "./map-style-json.js";

export default {
  name: "",
  data() {
    return {
      city: "",
      orgInfo: {},
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 2000,
        },
      },
      institution: [],
      ishow: null,
      detailInfo: null,
      activity: [],
      staffList: [],
      rightdata: [],
      menuData: [],
      organization: "",
      topinfoArr: [],
      orgId: '',
      orgData: [],
    };
  },
  created() {
    this.city = this.$route.query.city * 1;
    this.insId = this.$route.query.insId * 1;
    this.orgId = this.$route.query.orgId;
    console.log('city',this.city,'insId',this.insId,'orgId',this.orgId);

    this.showTopInfo();
    this.getright();
    this.getMenuList();
  },
  mounted() {
    this.getData();

    this.$nextTick(async () => {
      setTimeout(() => {
        Highcharts.chart(
          "highchart-disease-bar",
          diseaseBarChartOpts(
            this.getChartInfo(this.rightdata, "BI_HOME_CARE_SERV_DIS")
          )
        );
      }, 1000);
    });
  },
  methods: {
    showTopInfo() {
      this.institution = JSON.parse(this.$route.query.info);
      console.log("institution",this.institution);
      this.organization = this.institution.branchId;
      let toinfo = this.institution.siteBaseInfo;
      if (this.institution.orgPropertyType === 2) {//中心站点
        toinfo = this.institution.centralSiteBaseInfo;
      }
      this.topinfoArr  = toinfo.groupDataList.slice(0,5);
      if (toinfo == null) {
        this.ishow = false;
      } else {
        this.ishow = true;
        this.topinfo = toinfo;
      }
    },
    async refresLocalStorageHomeInfos() {
      const {data: orgRes} = await this.$http.get("/biDataDaily/operateInfo");
      localStorage.homeInfos = JSON.stringify(orgRes.data.children);
    },
    seleorg(val){
      var infoList = JSON.parse(localStorage.homeInfos);
      var city = this.city;
      infoList[city].children.forEach((item, index) => {
      // this.orgData.forEach((item, index) => {
        if(item.branchId == val){
          this.$router.push({
            name: 'org',
            query: {
              city: this.city,
              id: index
            },
          });
        }
      })
    },
    getMenuList() {
      var city = this.city;
      var insId = this.insId;
      var infoList = JSON.parse(localStorage.homeInfos);
      var infovalue = infoList[city].children[insId].children;
      console.log(infovalue,'infovalue')
      let array = infoList[city].children;
      let data = [];
      array.forEach((item, i) => {
        if (item.orgPropertyType != 1) {//去除站点
          data.push(item);
        }
      });
      this.orgData = data;
      if (infovalue !== null && infovalue.length > 0) {
        // console.log(infovalue[0].children, "getMenuList");
        // this.menuData = infovalue[0].children;
        this.menuData = infovalue;
      }
    },
    seleorganization(value) {
      this.refresLocalStorageHomeInfos();
      console.log(value);
      let indexi = this.menuData.findIndex(function (event) {
        return event.branchId === value;
      });
      console.log(indexi);
      console.log(this.menuData[indexi]);

      this.institution = this.menuData[indexi];
      let toinfo = this.institution.siteBaseInfo;
      if (this.institution.orgPropertyType === 2) {//中心站点
        toinfo = this.institution.centralSiteBaseInfo;
      }
      this.topinfoArr = toinfo.groupDataList.slice(0,5);
      if (toinfo == null) {
        this.ishow = false;
      } else {
        this.ishow = true;
        this.topinfo = toinfo;
      }

      this.getData();
      this.getright();
    },
    gotopage(value) {
      if(value == 'area'){
        this.$router.push({
        name: value,
        query: { city: this.city, insId: this.insId,orgId: this.orgId, },
      });
      }else{
        this.$router.push({
          name: value,
          query: { city: this.city, insId: this.insId },
        });
      }
      console.log(value);
    },
    async getright() {
      const res = await this.$http.post("/biDataDaily/typeBeanList", {
        branchId: this.institution.branchId,
        initZero: true,
      });
      this.rightdata = res.data.data;
      setTimeout(() => {
        Highcharts.chart(
          "highchart-disease-bar",
          diseaseBarChartOpts(
            this.getChartInfo(this.rightdata, "BI_HOME_CARE_SERV_DIS")
          )
        );
      }, 1000);
    },
    getData() {
      var that = this;
      this.$http({
        url: "/orgExtra/detail",
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: `id=${this.institution.branchId}`,
      }).then((res) => {
        that.detailInfo = res.data.data;
        console.log(that.detailInfo, "detailInfo");
      });

      this.$http
        .get(`/activities/ActivitiesInfo?branchId=${this.institution.branchId}`)
        .then((res) => {
          var list = res.data.data[0].photo;
          const chars = list.split(",");
          this.activity = chars;
          console.log(this.activity,'activity');
        });
      this.$http
        .get(`/biServiceStaff/listBeans?branchId=${this.institution.branchId}`)
        .then((res) => {
          console.log(res, "志愿者");
          var staffRes = res.data.data;
          console.log(staffRes);
          this.staffList = staffRes.find(
            (item) => item.staffType === "SERVICE_VOLUNTEER"
          ).staffList;
          console.log(this.staffList);
        });
    },

    goBack() {
      history.back();
    },
    onSlideChange($swiper) {
      // console.log($swiper.activeIndex);
    },
    getChartInfo(data, code) {
      console.log(data, code);
      if (data.length > 0) {
        return data.find((item) => item.typeCode === code);
      } else {
        return {};
      }
    },
  },
  computed: {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.home {
  width: 1920px;
  height: 1080px;
  background: url("../assets/home/bg.jpg");
}
.headera {
  width: 100%;
  height: 116px;
  background: url("../assets/home/logokuang.png") no-repeat;
  background-position: center bottom;
  position: relative;
  display: flex;
  align-items: center;
}

.logo {
  width: 100%;
  margin: 0 auto;
  line-height: 116px;
  font-size: 40px;
  color: #08fbfb;
  //margin-left: 12px;
  position: absolute;
  top: 0;
  left: 0;
}
.goBack {
  position: absolute;
  width: 55px;
  height: 42px;
  left: 50px;
  top: 20px;
  cursor: pointer;
}
.main {
  padding: 0 !important;
  display: block !important;
  height: calc(100% - 116px);
}
.mainTop {
  width: 100%;
  height: 180px;
  background: url("../assets/area/bjzs.png") no-repeat;
  /* position: relative; */
  z-index: 1;
}
.maTopInfo2 {
  width: 100%;
  height: 85%;
  z-index: 2;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-top: 10px;
}
.inItem2 {
  width: 25%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.smtopImg2 {
  width: 62px;
  height: 72px;
}
.infoValue2 {
  margin-left: 15px;
}

.topNum2 {
  text-align: left;
  font-size: 22px;
  padding: 0;
  margin: 0;
}
.topNum21 {
  text-align: left;
  color: #f7f489;
  display: flex;
  align-items: center;
  margin-top: 24px;
}
.topNum21 span {
  font-size: 14px;
  text-align: left;
}
.topNum21 span:nth-child(2) {
  color: #ffdf25;
  font-weight: bolder;
  font-size: 18px;
  margin-left: 5px;
}
.mainBottom {
  width: 95%;
  margin: 0 auto;
  display: flex;
  margin-top: 20px;
  height:calc(100% - 225px);
}
.btml {
  width: 25%;
  height: 100%;
}
.btmc {
  width: 50%;
  height: 100%;
  overflow: hidden;
}
.btmr {
  width: 25%;
  height: 100%;
}
.btmlitem {
  width: 100%;
  height: 50%;
  background-color: #13215e;
}
.textContent {
  padding: 10px 16px;
  text-align: left;
  text-indent: 2em;
  line-height: 28px;
}
.rimgItem {
  width: 100%;
  height: 100%;
  position: relative;
}
.swiper-container {
  position: relative;
  width: 90%;
  height: 87%;
  top: 0% !important;
  left: 0% !important;
}
.btmlitem .swiper-slide {
  width: 100%;
  height: 100%;
  background-color: transparent !important;
}
.swiper-slide img {
  width: 100%;
  height: 100%;
}
#highchart-disease-bar {
  width: 100%;
  height: 100%;
}
.tipsBox {
  // position: fixed;
  // left: 60px;
  // top: 20px;
  display: flex;
  align-items: center;
}
.tips {
  font-size: 30px;
  cursor: pointer;
  color: aqua;
  margin-left: 20px;
}
.stationSelect {
  position: absolute;
  right: 200px;
  top: 35px;
}
.staioName {
  position: absolute;
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: rgba(0, 0, 0, 0.4);
  font-size: 15px;
  bottom: 0px;
}
.datetime {
  width: 220px;
  z-index: 2;
  margin-left: 15px;
  // padding-right: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  span {
    color: #fff;
    font-size: 24px;
    font-weight: bold;
    line-height: 80px;
  }
}
.back {
  z-index: 2;
  text-align: left;
  box-sizing: border-box;
  // width: 300px;
  button {
    background: transparent;
    border: 0;
  }
}
.back1 {
  z-index: 2;
  text-align: left;
  box-sizing: border-box;
  // width: 300px;
  button {
    background: transparent;
    border: 0;
  }
}
::v-deep .el-select .el-input .el-select__caret{
  color: #c0c4cc00;
}
::v-deep .el-input__inner{
  background-color: #fff0;
  color: #08fbfb;
  border: 1px solid #08fbfb;
  font-size: 24px;
}
</style>
